const partialDropdown = require('../../../partials/src/uiPartials/civicsInputFields/uiCivicsDropdown.hbs');
const partialDropdownOption = require('rhythm-fe-ui-components/src/uiPartials/droppy/uiDroppyOption.hbs');

const partialDisplayField = require('../../../partials/src/uiPartials/civicsInputFields/uiCivicsDisplayFields.hbs');


const general_utils = require('civicsUtils/general_utilities');
const detailUtils = require('civicsUtils/detail_utilities');
const utils = require ('../detail_utilities.js');

define(function (require) {
	var getDropdown = function (ele, readOnlyForm, detailOptions) {
		var tableMoniker = ele.tableMoniker; //null if not in table
		//moniker will be filled in if it's in an instrument detail page. If we're in the wizard, the ID will suffice.
		var fieldMoniker = ele.moniker == null ? ele.id : ele.moniker;
		//we need a COPY of the detail page ID, because when the promise finishes, the detailOptions.detailPageID value may already have been changed if there are multiple detail pages.
		var copyOfDetailPageID = detailOptions.detailPageId+'';

		var customAttr = '';
		customAttr += !_.isEmpty(ele.specialType) ? 'specialType = \"' + ele.specialType + '\" ' : '';
		if ( ele.description )
		{
			customAttr += ' data-tooltip=" ' + general_utils.attributeEscapeString(ele.description) +  '" ';
		}
		var el;

		if(readOnlyForm){

			var description = ele.value;
			var descriptionPromise = $.Deferred();
			if(detailOptions && detailOptions.fromWizard === true){
				//if this is a wizard, we get our options from the valuselections. we don't call the services.
				detailUtils.storeOptions(copyOfDetailPageID, fieldMoniker , tableMoniker, ele.valueSelections);
				descriptionPromise.resolve();
			} else {
				descriptionPromise = detailUtils.loadOptions(copyOfDetailPageID,fieldMoniker,tableMoniker);
			}
			if(descriptionPromise.state()=='resolved'){
				description = detailUtils.getDescription(copyOfDetailPageID,fieldMoniker,tableMoniker,ele.value);
			} else {
				$.when(descriptionPromise).done(function(){
					//we're going to have to assume that the <p> has been rendered at this point. Otherwise, another detail page may have been generated, and the detail page ID could be different.
					var $p = $('#' + ele.id + '-text');
					var txt = $p.length == 1 ? $p.text().trim() : '';
					var dtlPgId = $p.parents('.detail-page-wrapper').data('detailOptions.detailpageid');
					var desc = detailUtils.getDescription(dtlPgId,fieldMoniker,tableMoniker,txt);
					$p.text(desc);
				});
			}
			//check to see if we're in the wizard or the detail page. If we're in the detail page, isHTML shouldn't be true.
			if(ele.isHtml && !detailOptions.fromWizard){
				ele.isHtml = false;
			}
			var displayData = {
				id: ele.id,
				name: ele.bind ? ele.bind : ele.id,
				classes: ele.isVisible === false ? 'hidden dropdown-container '+ ele.id + '-dropdown-container':'dropdown-container '+ ele.id + '-dropdown-container',
				disabled: (readOnlyForm || ele.isEnabled === false),
				containerId: ele.id + "-dropdown-container",
				textId: ele.id + "-text",
				required: ele.isRequired,
				labelText: ele.text,
				showValue: readOnlyForm,
				value: description,
				customAttr: customAttr,
				html:ele.isHtml
			};

			el = $(partialDisplayField($.extend({}, displayData)));

		} else {

			customAttr += !_.isEmpty(ele.value) ? 'initVal = \"' + ele.value + '\" ' : '';

			// Create Dropdown Container
			var dropdownData = {
				id: ele.id,
				qaid: utils.formatId(ele.text, ele.type),
				name: ele.bind ? ele.bind : ele.id,
				required: ele.isRequired,
				disabled: ele.isEnabled === false,
				classes: ele.isVisible === false ? 'hidden dropdown-container '+ ele.id + '-dropdown-container':'dropdown-container '+ ele.id + '-dropdown-container',
				customAttr: customAttr,
				labelText:ele.text,
				searchable: true
			};

			el = $(partialDropdown($.extend({}, dropdownData)));

			//we need to ensure there is a default option in the DDLs (Select...)
			var addDefaultOption = function($list){
				var found = false;
				var select = true;
				var $defaultOption;
				$.each($list.children(),function(index, opt){
					var $opt = $(opt);
					if($opt.attr('data-val') === ''){
						found = true;
						$defaultOption = $opt;
					}
					if($opt.hasClass('pre-selected')){
						select = false;
					}
				});
				if(!found){
					//i18n.t('CIVICS.INSTRUMENT_SUBMIT.ADD_ROW')
					var optionData = {
						value: '',
						text: i18n.t('CIVICS.COMMON.SELECT'),
						selected: select
					};

					$list.prepend(partialDropdownOption($.extend({}, optionData)));

					if(select){
						//now set up the associated textbox with the selection
						var $tb = $list.siblings('.droppy-input');
						$tb.val('');
						$tb.attr('title',i18n.t('CIVICS.COMMON.SELECT'));
						$tb.val(i18n.t('CIVICS.COMMON.SELECT'));
					}
				} else {
					$defaultOption.find('.option-content').text(i18n.t('CIVICS.COMMON.SELECT'));
				}
			};

			if(ele.valueSelections){
				detailUtils.storeOptions(copyOfDetailPageID, fieldMoniker , tableMoniker, ele.valueSelections);
				// Fill in options if they are available in the doc response
				var $list = el.find('.droppy-list').first();
				_.forEach(ele.valueSelections, function(value) {
					var optionData = {
						value: value.value,
						text: value.text,
						selected: value.selected
					};

					$list.append(partialDropdownOption($.extend({}, optionData)));

				});
				addDefaultOption($list);
			}
			// if the values are not included in the doc response, try fetching it through moniker.
			else if (ele.moniker && ele.moniker.length > 0) {
				var optionsPromise = detailUtils.loadOptions(copyOfDetailPageID,fieldMoniker,tableMoniker);
				$.when(optionsPromise).done(function(){
					// Because the field is already in the DOM, we need to find the dropdownlist element in order to append the options
					var $ddl = $("." + ele.id + "-dropdown-container .droppy-list");
					var $input = $("." + ele.id + "-dropdown-container input");
					var dtlPgId = $ddl.parents('.detail-page-wrapper').data('detailOptions.detailpageid');

					var options = detailUtils.getOptions(dtlPgId,fieldMoniker,tableMoniker);

					// Get current selected item
					var initVal = $("#" + ele.id).attr('initVal');
					var valFound = false;
					_.forEach(options, function (m, key) {
						valFound = (typeof initVal !== 'undefined' && initVal == m.code);
						// Fill in options data
						var optionData = {
							value: m.code,
							text: m.description,
							selected: valFound
						};

						$ddl.append(partialDropdownOption($.extend({}, optionData)));

						if(valFound === true){
							$input.val('');
							$input.attr('title', m.description);
							$input.val(m.description);
						}

					});
					addDefaultOption($ddl);
				});
			}
		}

		return el;
	};
	return {
		getDropdown: function(ele, readOnlyForm, detailOptions) {
			return getDropdown(ele, readOnlyForm, detailOptions);
		}
	}
});